export default "__VITE_ASSET__6a81ecbb__"